module.exports = __webpack_public_path__ + "static/img/4.f182cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/ltsj/4.png
// module id = 6uWN
// module chunks = 1